import React from 'react';
import './Snake.css'

const Snake = (props) => {
  return (
    <>
      {props.segments}
    </>
  )

}
export default Snake